{
    "SchedulereportLabel": "Programmer ce rapport :",
    "SchedulereportNotscheduledOptionLabel": "[Non programmé]",
    "SchedulereportOnceOptionLabel": "Une fois",
    "SchedulereportHourlyOptionLabel": "Horaire",
    "SchedulereportDailyOptionLabel": "Quotidiennement",
    "SchedulereportWeeklyOptionLabel": "Hebdomadaire",
    "SchedulereportMonthlyOptionLabel": "Mensuel",
    "SchedulereportResetButtonLabel": "Réinitialiser",
    "SchedulereportPromptReset": "Êtes-vous sûr de vouloir réinitialiser le programme ?",
    "SchedulereportPromptButtonConfirmLabel": "Confirmer",
    "SchedulereportPromptButtonCancelLabel": "Annuler",
    "ReportScheduling_SectionHeader": "Programmation des rapports",
    "NAME": "ReportScheduling"
}